module.exports = __webpack_public_path__ + "img/service-03.5699938c.svg";